export enum WorkflowType {
    Add = 'Add',
    Replace = 'Replace',
    Obsolete = 'Obsolete',
    Update = 'Update'
}
